export const baseUrl = "https://spotlight-stage-api.skill-mine.com";
export const group_id = "spotlight-stage";
export const BASE_URL = "https://poc-api.auth-zero.com";
export const CLEAINT_ID = "31b602c9-e013-4c5b-afb2-81c3d903bf24";
export const webUrl = "https://spotlight-stage.skill-mine.com";